export enum SaveActionType {
  SAVE = 'Save draft view to its originating view',
  SAVE_AS = 'Save draft view as a separate new view',
}
